import { defineRoute } from "@/utils/routes";

type ViewPerspectiveType = "overview" | "IAndI" | "blockages";

export const Routes = {
	Auth: {
		Login: defineRoute("/login"),
		ForgotPassword: defineRoute("/forgot-password"),
		ResetPassword: defineRoute<"/reset-password/:token/:userId", { token: string; userId: Dryp.UserId }>(
			"/reset-password/:token/:userId",
		),
		Onboard: defineRoute("/onboard"),
		SSO: defineRoute("/sso-auth"),
	},

	Dashboard: {
		Home: defineRoute("/"),
		Map: defineRoute<
			"/map",
			{},
			{
				lat?: number;
				lng?: number;
				zoom?: number;
				structures?: Dryp.StructureId;
				view?: ViewPerspectiveType;
				groups?: [Dryp.StructureGroupId];
			}
		>("/map"),
		Blockages: defineRoute("/blockages"),
		InfiltrationInflow: defineRoute("/infiltration-inflow"),
		PumpingStations: defineRoute("/pumping-stations"),
		Alarms: defineRoute<
			"/alarms",
			{},
			{ page?: number; pageSize?: number; filter?: { id: string; value: string }[] }
		>("/alarms"),
		Events: defineRoute("/events"),
		Overflow: defineRoute("/overflow"),
		Precipitation: defineRoute("/precipitation"),
		Structures: {
			Structures: defineRoute<"/structures", {}, { search?: string; page?: number }>("/structures"),
			Structure: defineRoute<"/structures/:id", { id: Dryp.StructureId }>("/structures/:id"),
			Blockage: defineRoute<"/structures/:id/blockage", { id: Dryp.StructureId }>("/structures/:id/blockage"),
			Properties: defineRoute<"/structures/:id/properties", { id: Dryp.StructureId }>(
				"/structures/:id/properties",
			),
		},
		Admin: {
			Organizations: defineRoute("/backoffice/organizations"),
			BackofficeUsers: defineRoute("/backoffice/users"),
			UserGroups: defineRoute("/administration/user-groups"),
			AddUserGroup: defineRoute("/administration/user-groups/new"),
			EditUserGroup: defineRoute<
				"/administration/user-groups/edit/:userGroupId",
				{ userGroupId: Dryp.UserGroupId }
			>("/administration/user-groups/edit/:userGroupId"),
			Users: defineRoute("/administration/users"),
			Groups: defineRoute("/groups"),
			Devices: defineRoute("/devices"),
			Billing: defineRoute("/billing"),
			Settings: defineRoute("/settings"),
		},
	},
} as const;
